module.exports = __webpack_public_path__ + "img/11-03_Being Detail-Oriented.f6510a86.svg";